skrilla.service('dataService', function(validationService) {
    var validation = validationService;

    function validateTournament(tournament, validateObj) {
        var inputs = [
            validation.buildFieldValidationObj("name", !validation.isEmpty(tournament.name), "Please enter a name"),
            validation.buildFieldValidationObj("categoryName", !validation.isEmpty(tournament.categoryName), "Please enter a category name")
        ];
        return validation.validateForm(inputs, validateObj)
    }

    function validateSeason(season, validateObj) {
        var inputs = [
            validation.buildFieldValidationObj("name", !validation.isEmpty(season.name), "Please enter a name"),
            validation.buildFieldValidationObj("startDate", validation.isDate(season.startDate) && !validation.isEmpty(season.startDate), "Please enter a start date"),
            validation.buildFieldValidationObj("endDate", validation.isDate(season.endDate) && !validation.isEmpty(season.endDate), "Please enter an end date"),
            validation.buildFieldValidationObj("dates", season.startDate <= season.endDate, "End date must be equal to or after start date")
        ];
        return validation.validateForm(inputs, validateObj)
    }

    function validateFranchise(franchise, validateObj){
        var inputs = [
            validation.buildFieldValidationObj("name", !validation.isEmpty(franchise.name), "Please enter a name"),
            validation.buildFieldValidationObj("abbreviation", !validation.isEmpty(franchise.abbreviation), "Please enter an abbreviation"),
            validation.buildFieldValidationObj("iconUri", validation.isEmpty(franchise.iconUri) || franchise.iconUri.startsWith("https://"), "Please enter a valid Icon Uri (https://)"),
            validation.buildFieldValidationObj("websiteUri", validation.isEmpty(franchise.websiteUri) || franchise.websiteUri.startsWith("https://"), "Please enter a valid Website Uri (https://)")
        ];
        return validation.validateForm(inputs, validateObj)
    }

    function validatePlayer(player, validateObj){
        var inputs = [
            validation.buildFieldValidationObj("lastName", !validation.isEmpty(player.lastName), "Please enter a lastName name"),
            validation.buildFieldValidationObj("nickName", !validation.isEmpty(player.nickName), "Please enter an nick name")
        ];
        return validation.validateForm(inputs, validateObj)
    }

    return {
        validateTournament:validateTournament,
        validateSeason: validateSeason,
        validateFranchise: validateFranchise,
        validatePlayer: validatePlayer
    };
});
